<!-- Not a <button>: the close action nests inside, and a button cannot contain another button. -->
<div
  class="assistant-gradient-border assistant-message-preview flex w-[280px] gap-2 rounded-xl p-3 text-left shadow-modal"
  data-testid="assistant-message-preview-root"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <!-- The design drops the avatar next to a video, so the thumbnail gets the full width. -->
  @if (!hasVideo()) {
    <lib-avatar-initials
      class="shrink-0 self-end"
      data-testid="assistant-message-preview-avatar"
      [name]="{ firstName: senderFirstName(), lastName: senderLastName() }"
      [hasBorder]="true"
      [size]="30"
    />
  }

  <div class="flex min-w-0 flex-1 flex-col gap-1">
    <div class="flex items-center justify-between gap-2">
      @if (senderFirstName()) {
        <span class="typo-h7-semibold truncate text-text-primary">{{ senderFirstName() }}</span>
      }

      @if (isExpanded()) {
        <button
          type="button"
          class="-m-1 shrink-0 p-1 text-text-secondary"
          data-testid="assistant-message-preview-close"
          [attr.aria-label]="'common_modal_close' | translate"
          (click)="onCloseClick()"
        >
          <svg-icon key="px-16-x" size="sm"></svg-icon>
        </button>
      }
    </div>

    <!-- Not a <button>: the rendered markdown can contain block elements and links, which a button
         cannot contain. The video thumbnail sits inside it, so it opens the chat like the text does. -->
    <div
      role="button"
      tabindex="0"
      class="flex cursor-pointer flex-col gap-2 text-left"
      data-testid="assistant-message-preview-content"
      (click)="onClick()"
      (keydown.enter)="onClick()"
      (keydown.space)="$event.preventDefault(); onClick()"
    >
      @if (text()) {
        <!-- Collapsed shows a single line; hovering expands to at most 11 lines (the 200px cap at this
             12px/14px type scale), or 3 lines above the video, and truncates the rest with an ellipsis. -->
        <div
          class="assistant-message-preview-text rich-text typo-h7-book overflow-hidden text-text-tertiary"
          [class.line-clamp-1]="!isExpanded()"
          [class.is-expanded]="isExpanded()"
          [class.has-video]="hasVideo()"
          data-testid="assistant-message-preview-text"
          libRichText
          [text]="text()"
        ></div>
      }

      @if (hasVideo()) {
        <!-- p-1 plus the 2px border gives the design's 6px inset, so the thumbnail is 68px high. -->
        <div class="h-20 w-full rounded-[20px] border-2 border-background-white p-1" data-testid="assistant-message-preview-video">
          <div
            class="relative flex h-full items-center justify-center overflow-hidden rounded-2xl shadow-[0px_0px_32px_0px_rgba(13,29,44,0.1),0px_0px_32px_0px_rgba(13,29,44,0.1)]"
          >
            <img
              crossorigin="anonymous"
              alt=""
              class="absolute inset-0 size-full object-cover"
              data-testid="assistant-message-preview-video-thumbnail"
              [src]="videoThumbnailUrl() ?? 'assets/images/collab-thumbnail-preview.png'"
            />
            <div class="relative flex size-10 items-center justify-center rounded-full bg-[rgba(66,66,66,0.4)] backdrop-blur-[2px]">
              <svg-icon class="!h-[14px] !w-3 text-text-white" key="px-12-play"></svg-icon>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
